<template>
  <van-popup
    closeable
    v-model="show"
    get-container="#app"
    :position="screenWidth > 767 ? 'center' : 'bottom'"
    :style="{
      'background-color': 'transparent',
    }"
  >
    <div class="optionsWarp">
      <h1>{{ langConfig.leagues[langConfig.curLang]['OPTIONAL'] }}</h1>
      <div class="funtion flex">
        <span @click="allSeletiton">{{ langConfig.leagues[langConfig.curLang]['SELECT_ALL'] }}</span
        ><span @click="invertSeletiton">{{ langConfig.leagues[langConfig.curLang]['INVERT_SELECTION'] }}</span>
      </div>
      <ul class="flex flex-warp">
        <li
          v-for="item in options"
          :key="item"
          :class="selected.includes(item) ? 'selected' : ''"
          @click="roundClick(item)"
        >
          {{ item }}
        </li>
      </ul>
      <div class="confirm" @click="confirm">{{ langConfig.leagues[langConfig.curLang]['CONFIRM'] }}</div>
    </div>
  </van-popup>
</template>
<script>
export default {
  props: ["options", "roundSelected"],
  data() {
    return {
      screenWidth: 0,
      show: false,
      selected: [],
    };
  },
  methods: {
    //获取屏幕宽度
    handleResize() {
      if (typeof window != "undefined") {
        this.screenWidth = window.innerWidth;
      }
    },
    showPopup() {
      this.show = true;
      this.selected = JSON.parse(JSON.stringify(this.roundSelected));
    },
    hidePopup() {
      this.show = false;
    },
    confirm() {
      this.$emit("optionsSelectedChange", this.selected);
      this.hidePopup();
    },
    roundClick(key) {
      if (this.selected.includes(key))
        this.selected = this.selected.filter((item) => item != key);
      else this.selected.push(key);
    },
    allSeletiton() {
      this.selected = JSON.parse(JSON.stringify(this.options));
    },
    invertSeletiton() {
      let union, interselect, difference;
      union = [...new Set([...this.options, ...this.selected])]; // 并集（全选），去重
      interselect = this.options.filter((item) => this.selected.includes(item)); // 交集
      difference = union.filter((item) => !interselect.includes(item)); // 差集（反选）
      this.selected = difference;
    },
  },
  created() {
    if (typeof window != "undefined") {
      this.screenWidth = window.innerWidth;
    }
  },
  mounted() {
    if (typeof window != "undefined") {
      window.addEventListener("resize", this.handleResize);
    }
  },
  beforeDestroy() {
    if (typeof window != "undefined") {
      window.removeEventListener("resize", this.handleResize);
    }
  },
};
</script>
<style lang="less">
.optionsWarp {
  width: 540px;
  padding: 24px 16px;
  border-radius: 16px;
  background-color: #fff;
  position: relative;
  h1 {
    font-size: 24px;
    font-weight: 700;
    color: @color_434343;
  }

  ul {
    max-height: 32px * 7 + 6px * 6;
    overflow: auto;
    li {
      width: calc((100% - 8px) / 2);
      height: 32px;
      line-height: 30px;
      text-align: center;
      border: 1px solid @color_D9D9D9;
      border-radius: 8px;
      font-size: 16px;
      cursor: pointer;
      &:nth-child(2n) {
        margin: 0 0 8px 8px;
      }
      &:hover {
        background-color: @color_F0F0F0;
      }
      &.selected {
        border-color: @color_FF6915;
        background-color: @color_FFF7F2;
      }
    }
  }
  .funtion {
    margin: 16px 0;
    span {
      display: inline-block;
      padding: 0 16px;
      border-radius: 12px;
      height: 22px;
      line-height: 22px;
      border: 1px solid @color_BFBFBF;
      margin-right: 8px;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        background-color: @color_F0F0F0;
      }
    }
  }
  .confirm {
    width: 262px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    background-color: @color_FF6915;
    border-radius: 8px;
    margin: 8px auto 0;
    font-size: 16px;
    cursor: pointer;
  }
}
@media screen and (max-width: 767px) {
  .optionsWarp {
    width: 100%;
    padding: 0.24rem 0.24rem 0.16rem 0.24rem;
    border-radius: 0.2rem 0.2rem 0 0;
    h1 {
      font-size: 0.18rem;
    }

    ul {
      max-height: 0.32rem * 11 + 0.08rem * 9;
      li {
        width: calc((100% - 0.08rem) / 2);
        height: 0.32rem;
        line-height: 0.3rem;
        border-radius: 0.08rem;
        font-size: 0.14rem;
        &:nth-child(2n) {
          margin: 0 0 0.08rem 0.08rem;
        }
      }
    }
    .funtion {
      margin: 0.16rem 0;
      span {
        display: block;
        padding: 0 0.16rem;
        border-radius: 0.12rem;
        height: 0.22rem;
        line-height: 0.22rem;
        margin-right: 0.08rem;
        font-size: 0.14rem;
      }
    }
    .confirm {
      width: 100%;
      height: 0.4rem;
      line-height: 0.4rem;
      border-radius: 0.08rem;
      margin: 0.1rem auto 0;
      font-size: 0.16rem;
    }
  }
}
</style>




// WEBPACK FOOTER //
// ./src/views/leagues/components/optionsFilter.vue